import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AngularMaterialModule } from '../../../../angular-material.module';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../../../environments/environment';
import { SearchableDropdownComponent } from '../../../../common/searchable-dropdown/searchable-dropdown.component';
import { SearchableOptionsPipe } from '../../../../common/searchable-dropdown/searchable-options.pipe';

export interface StatusUpdateData {
  item: {
    issue_id: number;
    status: number | string;
    description?: string;
    comment?: string;
    status_name?: string;
    reported_name?: string;
    category_name?: string;
    block?: string;
    floor_unit?: string;
    created_at?: string;
  };
}

@Component({
  selector: 'app-update-satatus',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    AngularMaterialModule,
    CommonModule,
    SearchableDropdownComponent,
    SearchableOptionsPipe,
  ],
  templateUrl: './update-satatus.component.html',
  styleUrl: './update-satatus.component.scss'
})
export class UpdateSatatusComponent implements OnInit {
  statusList: any[] = [];
  baseUrl = environment.baseUrl;
  accountID = sessionStorage.getItem('account_id');
  userID = sessionStorage.getItem('session_id');
  submitting = signal<boolean>(false);

  statusUpdateForm = new FormGroup({
    issue_id: new FormControl<number | null>(null),
    status: new FormControl<number | string | null>(null, Validators.required),
    comment: new FormControl<string | null>(null, Validators.required),
  });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UpdateSatatusComponent>
  ) {}

  ngOnInit(): void {
    if (this.data && this.data.item) {
      this.initializeForm(this.data.item);
      this.fetchAllStatus();
    }
  }

  initializeForm(item: any) {
    const statusVal = item.status !== undefined && item.status !== null ? Number(item.status) : null;
    this.statusUpdateForm.patchValue({
      issue_id: item.issue_id,
      status: Number.isNaN(statusVal) ? item.status : statusVal,
      comment: item.comment || '',
    });
  }

  fetchAllStatus() {
    this.http.get(`${this.baseUrl}/status_dropdown`).subscribe({
      next: (res: any) => {
        this.statusList = Array.isArray(res) ? res : (res?.data ?? []);
      },
      error: (err: any) => this.handleError(err, 'Failed to fetch statuses'),
    });
  }

  handleError(error: any, message: string) {
    console.error(message, error);
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  onSubmit() {
    this.statusUpdateForm.markAllAsTouched();
    if (!this.statusUpdateForm.valid) {
      this.snackBar.open('Please fill all required fields.', 'Close', { duration: 3000 });
      return;
    }

    this.submitting.set(true);
    const formValue = this.statusUpdateForm.value;

    const payload = {
      issue_id: formValue.issue_id,
      status: formValue.status,
      updated_by: this.userID,
      account_id: this.accountID,
      comment: formValue.comment,
    };

    this.http.post(`${this.baseUrl}/update_issue_status`, payload).subscribe({
      next: (response) => {
        this.snackBar.open('Status updated successfully!', 'Close', { duration: 3000 });
        this.dialogRef.close(response);
      },
      error: (err) => {
        console.error('Error updating status:', err);
        this.snackBar.open('Failed to update status, please try again later.', 'Close', { duration: 3000 });
        this.submitting.set(false);
      },
    });
  }
}
